import { FC, memo, useEffect } from "react";

import Toast from "components/Toast";

import { RootStore } from "store";
import { useAppDispatch } from "store/hooks";
import { hideToast } from "store/slices/toastSlice";

type ToastEntry = RootStore["toast"]["toasts"][number];

const TimedToast: FC<ToastEntry> = ({ id, duration, type, message }) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (duration <= 0) {
      return;
    }

    const timerId = window.setTimeout(() => {
      dispatch(hideToast(id));
    }, duration);

    return () => window.clearTimeout(timerId);
  }, [dispatch, duration, id]);

  return <Toast type={type} message={message} />;
};

export default memo(TimedToast);
